import { Main } from 'ui/components/4-habitats/Main/Main';
import { ModuleFeature } from 'features/Modules/DynamicModule/DynamicModuleFeature';
import { Footer } from 'ui/components/4-habitats/Footer/Footer';
import { footerMapper } from 'helpers/mappers';
import { FilterHero } from 'ui/components/3-organisms/FilterHero/FilterHero';
import { usePageContext } from 'application/contexts/PageContext';
import { TagsFetcher } from './TagsFetcher';
import { NewsList } from 'ui/components/3-organisms/NewsList/NewsList';
import { NewsFetcher } from 'features/Modules/NewsList/NewsFetcher';
import { FilterProps } from 'ui/components/2-molecules/Filter/Filter';
import { Spinner } from 'ui/components/1-atoms/Media/Spinner/Spinner';
import { useState } from 'react';
import { useSiteContext } from 'application/contexts/SiteContext';
import { useDictionaryContext } from 'application/contexts/DictionaryContext';

export const FilteredLibraryPageFeature: React.FC<Content.FilteredLibraryPage> = ({ properties }) => {
	const pageContext = usePageContext();
	const siteContext = useSiteContext();
	const dictionary = useDictionaryContext();
	const footerArgs = footerMapper(pageContext.footer, siteContext.settings.globalTheme?.setTheme, dictionary);
	const { heading, pageSections, buttonText } = properties ?? {};
	const pageId = pageContext.id;
	const tagsFolderId = properties.filterTagsNode.id;
	const { tags } = TagsFetcher(tagsFolderId);
	const [activeTag, setActiveTag] = useState<Tags.Tag | null>(null);

	const allTranslation = dictionary.getValue('All');

	const filterHero = {
		title: heading,
		filter: {
			items: tags?.map((tag) => ({
				children: tag.tagName,
				title: tag.tagName,
				onClick: () => setActiveTag(tag),
			})),
		} as FilterProps,
	};

	return (
		<>
			<Main header={<FilterHero {...filterHero} />}>
				{!tags?.length ? (
					<Spinner style="large" />
				) : (
					<NewsList
						count={0}
						offset={0}
						rootFolderId={pageId}
						newsFetcher={(rootId, limit, offset, filter) => NewsFetcher(rootId, limit, offset, filter, activeTag, allTranslation)}
						filter={!activeTag ? '[]' : `[{alias: "tags", values: ["${activeTag?.guid.replaceAll('-', '')}"] }]`}
						buttonText={buttonText}
					/>
				)}

				{pageSections.map((sectionModule, index) => (
					<ModuleFeature key={index} contentModule={sectionModule} />
				))}
			</Main>
			{footerArgs && <Footer {...footerArgs} />}
		</>
	);
};
